type Params = Record<string, unknown>

export function formatLocationUpsertRule(params: Params): string {
  const county = params.county ?? '—'
  return `County: ${county}`
}

export const LOCATION_OVERRIDE_RULE_PATTERN_FORMATTER: Record<
  string,
  (params: Params) => string
> = {
  UPSERT_RULE: formatLocationUpsertRule,
}
